import { render, staticRenderFns } from "./CommentShareDialog.vue?vue&type=template&id=53ead9a2&scoped=true"
import script from "./CommentShareDialog.vue?vue&type=script&lang=js"
export * from "./CommentShareDialog.vue?vue&type=script&lang=js"
import style0 from "./CommentShareDialog.vue?vue&type=style&index=0&id=53ead9a2&prod&lang=scss&scoped=true"
import style1 from "./CommentShareDialog.vue?vue&type=style&index=1&id=53ead9a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ead9a2",
  null
  
)

export default component.exports